import type { piniaPlaceHolder, TODO } from '../util/types';
import { type NuxtApp, useNuxtApp } from 'nuxt/app';
// import type { App } from "vue";
import type { apiNuxt } from '../api/apiNuxt';

class WorkflowStatusOption {
  statusName: string;
  statusNameLabel: string;
  updateStatusUrl: string;

  constructor(data: WorkflowStatusOption) {
    this.statusName = data.statusName;
    this.statusNameLabel = data.statusNameLabel;
    this.updateStatusUrl = data.updateStatusUrl;
  }
}

class Workflow {
  statusOptions: WorkflowStatusOption[];

  constructor(statusOptions: WorkflowStatusOption[]) {
    this.statusOptions = statusOptions;
  }
}

class Invite {
  app: NuxtApp['vueApp'] & {
    $nuxt: NuxtApp & {
      $API: ReturnType<typeof apiNuxt>['API'];
    };
  };
  actions: TODO;
  channelId: number;
  channelName: string;
  completed: boolean;
  createDateTimeMillis: number;
  email: string;
  expirationDateTimeMillis: number;
  id: number;
  invitedByUser: TODO;
  invitedUser: TODO;
  message: string;
  teamId: number;
  teamName: string;
  workflow: Workflow;

  constructor(data: {
    // app: App<Element>;
    actions: TODO;
    channelId: number;
    channelName: string;
    completed: boolean;
    createDateTimeMillis: number;
    email: string;
    expirationDateTimeMillis: number;
    id: number;
    invitedByUser: TODO;
    invitedUser: TODO;
    message: string;
    teamId: number;
    teamName: string;
    workflow: Workflow;
  }) {
    this.app = useNuxtApp().vueApp as NuxtApp['vueApp'] & {
      $nuxt: NuxtApp & {
        $API: ReturnType<typeof apiNuxt>['API'];
      };
    };
    this.actions = data.actions;
    this.channelId = data.channelId;
    this.channelName = data.channelName;
    this.completed = data.completed;
    this.createDateTimeMillis = data.createDateTimeMillis;
    this.email = data.email;
    this.expirationDateTimeMillis = data.expirationDateTimeMillis;
    this.id = data.id;
    this.invitedByUser = data.invitedByUser;
    this.invitedUser = data.invitedUser;
    this.message = data.message;
    this.teamId = data.teamId;
    this.teamName = data.teamName;
    this.workflow = data.workflow;
  }

  async acceptDecline({
    transitionName,
  }: {
    transitionName: string;
  }): Promise<void> {
    const pinia = useNuxtApp().$pinia as piniaPlaceHolder;
    const Query = pinia.$Query;

    await this.app.config.globalProperties.$axios.$patch(
      this.app.$nuxt.$API.channels.updateMemberInvitationStatus(
        this.channelId,
        this.teamId,
        this.id,
        new Query({ transitionName }).getQueryParameters()
      )
    );
  }
}

export type InviteInput = ConstructorParameters<typeof Invite>[0];

export default Invite;
